module.exports = __webpack_public_path__ + "img/经典面膜白底.35433846.jpg";